import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { cls_colorCyan70, cls_gap_half_rem, cls_p4b, cls_p5r } from "style/index.css";
import { cls_box_text_box } from "style/box_text.css";
export var Adjudicators = function (props) {
    return React.createElement(React.Fragment, null,
        props.varyingAdjudicators === true && React.createElement(HBox, { className: cls_p5r }, "Porota byla losov\u00E1na pro ka\u017Ed\u00E9 kolo zvl\u00E1\u0161\u0165."),
        props.adjudicators.length > 0 && React.createElement(HBox, null,
            React.createElement(VBox, { className: [cls_box_text_box, cls_gap_half_rem] },
                React.createElement(HBox, { className: [cls_p4b, cls_colorCyan70] }, 'Porota'),
                React.createElement(VBox, { className: cls_p5r }, props.adjudicators.map(function (o, oi) { return React.createElement(HBox, { key: "".concat(o.id, "_").concat(oi) }, "".concat(o.surname, " ").concat(o.name, " (").concat(o.country, ")")); })))));
};
